import { IJourney } from "@interfaces/IJourney";
import { IVehicle } from "@interfaces/IVehicle";
import { TranslationService } from "@services/translation.service";
import * as angular from "angular";
import { CameraService } from "../../services/camera.service";
import "./journeyOverviewCard.scss";

class JourneyOverviewCardComponentController implements angular.IComponentController {

    journey: IJourney;
    vehicle: IVehicle;

    journeyStatus: string

    startIcon: string;
    endIcon: string;

    totalEventsCount: number = 0;

    journeyOverviewCardClick: (args: { journey: IJourney }) => void;

    static $inject = ['cameraService', "translationService"];

    constructor(
        private readonly cameraService: CameraService,
        private readonly translationService: TranslationService
    ) { }

    $onInit() {    
        this.setJourneyStatus();
        this.setIcons();
        this.setEventsCount();
    }

    onJourneyCardClick() {
        if (this.journeyOverviewCardClick) {
            this.journeyOverviewCardClick({ journey: this.journey });
        }
    }

    //-------------
    private setJourneyStatus() {
        this.journeyStatus = '';

        if (this.journey?.isCurrent) {
            this.journeyStatus = this.translationService.t('journeyOverviewCard.inProgress');
        }
        else if (!this.journey?.isCurrent && (this.journey?.EndLocationInformation || this.journey?.EndUtc)) {
            this.journeyStatus = this.translationService.t('journeyOverviewCard.completed');
        }
    }

    private setEventsCount() {
        this.totalEventsCount = this.cameraService.getFilteredEventsForVideo(this.journey.events).length;
    }

    private setIcons() {
        this.journey?.events?.forEach(event => {
            if (event.label == 'Start') {
                this.startIcon = event.icon;
            }

            if (event.label == 'Stop') {
                this.endIcon = event.icon;
            }

            if (event.label == 'Current Position') {
                this.endIcon = event.icon;
            }
        })
}
}

export class JourneyOverviewCardComponent implements angular.IComponentOptions {
    bindings: any;
    template: string;
    controller: any;

    constructor() {
        this.bindings = {
            journey: "<",
            vehicle: "<",
            journeyOverviewCardClick: "&"
        };

        this.controller = JourneyOverviewCardComponentController;

        this.template = require("./journeyOverviewCard.html");
    }
}
